// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"92fe8ad3","443":"699dfcdb","721":"92fe8ad3"}[chunkId] + ".chunk.css";
};